const e={small:{size:16},middle:{size:24},large:{size:30}};export{e as CLOSE_ICON_SIZE};
//# sourceMappingURL=Modal.constants.js.map
